<template>
  <div class="profile-page-payTips">
    <div>
      <div class="vip-desc-box">
        <div v-if="isOk" class="vip-desc">
          Payment successful, thank you for your support
        </div>
        <div v-if="!isOk" class="vip-desc">
          We encountered some payment issues, please try again later
        </div>
      </div>
      <div class="disclaimer-btn">
        <div @click="okClick" class="disclaimer-btn-allow">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "share",
  props: {
    isOk: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      
    };
  },
  async mounted() {
    
  },
  methods: {
    async okClick() {
      this.$emit("okClick");
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.profile-page-payTips {
  color: #ffffff;
}
.vip-desc-box {
  display: flex;
  justify-content: center;
  .vip-desc {
    color: #000000;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    width: 419px;
    word-break: keep-all;
  }
}
.disclaimer-btn{
  display: flex;
  align-items: center;
  height: 100px;
  justify-content: space-around;
  .disclaimer-btn-decline{
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #4D52DE;
    cursor: pointer;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
  }
  .disclaimer-btn-allow{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50px;
    border-radius: 10px;
    opacity: 1;
    background: #4D52DE;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Microsoft YaHei','PingFang SC';
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
